import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Cart } from '@grandvisionhq/carts-v2';
import { Card } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { PaypalOrderButton } from '@grandvisionhq/payments';
import '@grandvisionhq/state';
import '../context/CheckoutSettings/context.js';
import '@grandvisionhq/utils';
import '../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../mappers/errors-mapping.js';
import '../utils/get-customer-details-payload.js';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';
import 'history';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/auth';
import '../selectors.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-service-store.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import { ShippingObjectTypes } from '../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import 'throttle-debounce';
import { useIsFormSlotAvailable } from '../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { ExpressCheckoutFormContainer } from '../modules/ExpressCheckout/components/ExpressCheckoutFormContainer/ExpressCheckoutFormContainer.js';
import { LoaderModal } from '../modules/LoaderModal/LoaderModal.js';
import '@grandvisionhq/bloomreach';

const ExpressOverview = ({ addresses , contactDetails , shippingMethodInfo , labels , isUpdating , onNextClick , dobFormRef ,  })=>{
    const { Slots  } = useBaseSummarySlot();
    const isExpressFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.ExpressCheckout);
    const AddressesSummarySlot = Slots.addresses;
    const ContactDetailsSummarySlot = Slots.contactDetails;
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-overview"
    }, /*#__PURE__*/ React.createElement(LoaderModal, {
        isModalOpen: isUpdating,
        subheading: labels.paymentInProgress
    }), /*#__PURE__*/ React.createElement("div", {
        className: "express-overview__details"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.yourDetails), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.completed.shipmentDetailsDelivery), /*#__PURE__*/ React.createElement(Card.Text, null, shippingMethodInfo))), AddressesSummarySlot && /*#__PURE__*/ React.createElement(AddressesSummarySlot, swcHelpers.extends({}, addresses)), ContactDetailsSummarySlot && /*#__PURE__*/ React.createElement(ContactDetailsSummarySlot, swcHelpers.extends({}, contactDetails))), isExpressFormAvailable && /*#__PURE__*/ React.createElement("div", {
        className: "express-overview__form",
        ref: dobFormRef
    }, /*#__PURE__*/ React.createElement(ExpressCheckoutFormContainer, null)), /*#__PURE__*/ React.createElement(Cart, null), /*#__PURE__*/ React.createElement(Text, {
        className: "express-overview__implicit-terms"
    }, labels.implicitTerms), /*#__PURE__*/ React.createElement("div", {
        className: "express-overview__action"
    }, /*#__PURE__*/ React.createElement(PaypalOrderButton, {
        isLoading: isUpdating,
        onClick: onNextClick,
        isDisabled: false
    })));
};

export { ExpressOverview };
//# sourceMappingURL=ExpressOverview.js.map
